import React from 'react'
import CheckBox from '@Components/Selectors/Checkbox'
import { SelectedPublisher } from '@App/stores/rightsholder/catalogTransfer/catalog-transfer-wizard-store'

interface TransferSelectionPanelProps {
    selectedPublishers: SelectedPublisher[]
    onRemovePublisher: (ipId: string) => void
}

const TransferSelectionPanel = ({ selectedPublishers, onRemovePublisher }: TransferSelectionPanelProps) => (
    <section className="transfer-selection-panel" aria-labelledby="transfer-selection-title">
        <h3 id="transfer-selection-title">Transfer Selection ({selectedPublishers.length})</h3>
        {selectedPublishers.length ? (
            <ul className="selection-list">
                {selectedPublishers.map((publisher) => (
                    <li key={publisher.ipId} className="selection-item">
                        <CheckBox
                            id={`selected-${publisher.ipId}`}
                            mainColor
                            checked
                            className="selection-remove-checkbox"
                            ariaLabel={'Remove ' + publisher.name}
                            onClick={() => onRemovePublisher(publisher.ipId)}
                        />
                        <span className="selection-name">{publisher.name}</span>
                    </li>
                ))}
            </ul>
        ) : (
            <div className="selection-empty">
                <strong>Nothing selected yet</strong>
                <p>
                    Use the search to find publishers, then select which ones to transfer works from. They&apos;ll be
                    displayed here.
                </p>
            </div>
        )}
    </section>
)

export default TransferSelectionPanel
